import DefaultTheme from './DefaultTheme';
import { colors } from './colors';

// FIXME: Check that the following interface
// is complete and according to specifications.
// The theme object should be flat and only
// contain properties that are communicated
// to the customers and currently mantained
interface Theme {
  name: string;
  i18nNamespace?: string;
  shopLogo?: string;
}

export {
  DefaultTheme,
  colors,
  Theme,
}
